const initialState = {
  topics: null, // media object
  currentTopic: null,
  isOpen: false,
  area: null,
  comments: {
    fetching: false,
    fetched: false,
    saving: false,
    saved: false,
    error: null,
    items: [],
    nbResult: 0
  }
};

export const topicViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_TOPIC_VIEWER": {
      return initialState;
    }
    case "OPEN_TOPIC_VIEWER": {
      return { ...state, ...action.viewer };
    }
    case "SET_CURRENT_TOPIC_VIEWER": {
      return { ...state, currentTopic: action.media };
    }
    case "FETCH_SINGLE_TOPIC_FULFILLED": {
      const { data } = action.payload.data;
      return {
        ...state,
        currentTopic: { ...data[0] }
      };
    }
    case `FETCH_TOPIC_COMMENTS_PENDING`: {
      return {
        ...state,
        comments: { ...state.comments, fetched: false, fetching: true }
      };
    }
    case `FETCH_TOPIC_COMMENTS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        comments: {
          ...state.comments,
          fetching: false,
          fetched: true,
          error: null,
          items: data,
          nbResult: nbResult
        }
      };
    }
    case `FETCH_TOPIC_COMMENTS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        comments: {
          ...state.comments,
          fetching: false,
          error
        }
      };
    }
    case `SAVE_TOPIC_COMMENT_PENDING`: {
      return {
        ...state,
        comments: {
          ...state.comments,
          saved: false,
          saving: true
        }
      };
    }
    case `SAVE_TOPIC_COMMENT_FULFILLED`: {
      const { data } = action.payload.data;
      const { comments } = state;

      const object = comments.items.find(item => item.id === data.id);
      if (!object) {
        const a = [data, ...comments.items];
        const o2 = a.sort((a, b) => {
          return (
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          );
        });
        return {
          ...state,
          comments: {
            ...state.comments,
            saving: false,
            saved: true,
            items: o2,
            nbResult: state.nbResult + 1
          }
        };
      }

      const newObj = { ...object, ...data };
      const newObjs = comments.items.map(item => {
        return item.id === newObj.id ? newObj : item;
      });

      const o2 = newObjs.sort((a, b) => {
        return (
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        );
      });

      return {
        ...state,
        comments: {
          ...state.comments,
          items: o2
        }
      };
    }
    case `SAVE_TOPIC_COMMENT_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        comments: {
          ...state.comments,
          saving: false,
          saved: false,
          error
        }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/topic-viewer.js